import { api } from "api";

import { UserPermissions } from "domain/users";

export interface GetPermissionsParams {
  userId: number;
  accountId: number;
}

export type GetPermissionsResponse = UserPermissions;

const PATH = "/auth/v2/permissions";

export const getPermissionsRequest = async (params: GetPermissionsParams) => {
  const res = await api.get<GetPermissionsResponse>(PATH, {
    params,
  });

  return res.data;
};
